import { Component } from '@angular/core';

@Component({
  selector: 'app-top-menu-component',
  templateUrl: './topMenu.component.html',
  styleUrls: ['./topMenu.component.scss'],
})
export class TopMenuComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/container/views/TopMenuComponent/topMenu.component.ts